import {AfterViewInit, Directive, ElementRef, HostListener, Input} from '@angular/core';
import {NgControl} from "@angular/forms";

@Directive({
  selector: '[vssUiMaxlengthInput]'
})
export class SetMaxlengthInputDirective implements AfterViewInit{
  @Input() vssUiMaxlengthInput: number = 256

  constructor(
    private el: ElementRef,
    private control: NgControl
  ) {
  }

  ngAfterViewInit() {
    this.el.nativeElement.querySelectorAll('input').forEach(
      (s: any) => {
        s.setAttribute('maxlength', this.vssUiMaxlengthInput)
      }
    )
    this.el.nativeElement.setAttribute('maxlength', this.vssUiMaxlengthInput)
  }
}
